"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var calcSize = function (width, from, to, min, max) {
    return min + (max - min) * ((width - from) / (to - from));
};
/**
 * Returns modular scale value
 * @param  {number} steps - Step of the modular scale
 * @param  {number} base - Base size of the modular scale
 * @param  {number} ratio - Ratio of the modular scale
 * @example modularScale(3, 16, 1.67)
 * @returns {number} Resulting modular scale value
 */
exports.modularScale = function (steps, base, ratio) {
    return base * Math.pow(ratio, steps);
};
/**
 * Transform px value to rem value.
 * @param {number} px - PX value as a integer. e.g. 12
 * @returns {string} - PX value in REM
 * @example ${px2rem(25)}
 */
exports.px2rem = function (px) { return (px / 16).toFixed(3) + "rem"; };
/**
 * Returns adaptive modular scale css font-size string
 * @param  {number} step - Step of the modular scale
 * @param  {object} config - Config object with base, ratio, width and breakpoints key
 * @example adaptiveModularScale(3, { base: [14, 16], ratio: [1.4, 1.67], width: [320, 960], breakpoints: 10 })
 * @returns {string} Resulting adaptive modular scale css font-size string
 */
exports.adaptiveModularScale = function (step, config) { return function (props) {
    var _a;
    var settings = ((_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.adaptiveModularScale) || config;
    if (typeof settings === 'undefined') {
        throw Error('No config or theme object with adaptiveModularScale key provided.');
    }
    var width = settings.width, base = settings.base, ratio = settings.ratio, breakpoints = settings.breakpoints, corrections = settings.corrections, lineHeights = settings.lineHeights;
    var cssProp = config && config.property ? config.property : 'font-size';
    var lineHeight = lineHeights && lineHeights[step] ? lineHeights[step] : undefined;
    var correction = corrections && corrections[step] ? corrections[step] : [0, 0];
    var minSize = exports.modularScale(step, base[0], ratio[0]) + correction[0];
    var maxSize = exports.modularScale(step, base[1], ratio[1]) + correction[1];
    var numberOfBreakpoints = breakpoints || 8;
    var steps = (width[1] - width[0]) / numberOfBreakpoints;
    var breakpointsString = "";
    for (var i = width[0] + steps; i <= width[1]; i += steps) {
        var size = calcSize(i, width[0], width[1], minSize, maxSize);
        var lh = lineHeight
            ? "line-height: " + calcSize(i, width[0], width[1], lineHeight[0], lineHeight[1]) + ";"
            : '';
        var mediaQuery = exports.px2rem(i);
        var fontSize = exports.px2rem(size);
        breakpointsString += "@media (min-width: " + mediaQuery + ") { " + cssProp + ": " + fontSize + "; " + lh + " }";
    }
    return cssProp + ": " + exports.px2rem(minSize) + "; " + (lineHeight ? "line-height: " + lineHeight[0] + ";" : '') + " " + breakpointsString;
}; };
exports.default = exports.adaptiveModularScale;
//# sourceMappingURL=index.js.map